import React from "react";
import DataTable from "./../../partials/table/DataTables.js";
import conf from "./../../../config.js";
import axios from "axios";
import tokenApi from "../../auth/Helpers";
import { Modal } from "react-bootstrap";
import SweetAlert from "sweetalert2-react";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import swal from "sweetalert2";
import { UserButtonLoading } from "../../partials/loadings/ComponentLoading.js";

// Premium select styles matching TambahSiswaKeRombel
const selectStyles = {
  control: (styles, { isFocused, isDisabled }) => ({
    ...styles,
    borderRadius: "12px",
    minWidth: "12rem",
    border: isFocused ? "2px solid #6366f1" : "1px solid #e5e7eb",
    boxShadow: isFocused ? "0 0 0 3px rgba(99, 102, 241, 0.1)" : "none",
    backgroundColor: isDisabled ? "#f3f4f6" : "white",
    "&:hover": {
      borderColor: isDisabled ? "#e5e7eb" : "#6366f1",
    },
  }),
  option: (styles, { isSelected, isFocused }) => ({
    ...styles,
    backgroundColor: isSelected ? "#6366f1" : isFocused ? "#eef2ff" : "white",
    color: isSelected ? "white" : "#1f2937",
  }),
};

const dataKurikulum = [
  { value: "k13", label: "K13" },
  { value: "merdeka", label: "Merdeka" },
];

export default class SiswaRombel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // URLs
      url: `${conf.uri_backend}api/v1/rombel/siswa`,
      url_get_rombel: `${conf.uri_backend}api/v1/rombel/get_rombel`,
      url_get_spektrum: `${conf.uri_backend}api/v1/rombel/get_spektrum`,
      url_get_smk: `${conf.uri_backend}api/v1/referensi/struktur-kurikulum`,
      url_delete: `${conf.uri_backend}api/v1/rombel/siswa_delete`,
      url_pindah_rombel: `${conf.uri_backend}api/v1/rombel/kenaikan`,
      url_tambah_alumni: `${conf.uri_backend}api/v1/rombel/alumni`,

      // Session & Institution
      data_session: null,
      institusi_id_select: null,
      jenjang_id_select: null,
      tahunSekarang: new Date().getFullYear(),

      // Alert states
      show_alert: false,
      title_alert: "",
      message_alert: "",
      icon_alert: "",

      // Filter values
      tahun_ajaran_search: "",
      kurikulum_search: "",
      kelas_search: "",
      peminatan_search: "",
      bidang_search: "",
      program_search: "",
      kompetensi_search: "",
      rombel_search: "",
      rombel_search_label: "",
      searchText: "",

      // Filter data options
      data_tahun_ajaran: [],
      data_kelas: [],
      data_peminatan: [],
      data_bidang: [],
      data_program: [],
      data_kompetensi: [],
      data_rombel: [],

      // Loading states
      loadingFilter: true,
      loading_peminatan: false,
      loading_bidang: false,
      loading_program: false,
      loading_kompetensi: false,
      loading_rombel: false,
      loading_action: false,

      // Display states
      showDataTable: false,
      mode_show: 10,
      query: "",

      // Multiple selection using Map for persistence
      selectedStudents: new Map(),

      // Modal states
      showPindahModal: false,
      showKeluarkanModal: false,
      pindah_rombel_target: "",
      pindah_rombel_target_label: "",
      data_rombel_target: [],
    };

    // Bind methods
    this.loadInitialData = this.loadInitialData.bind(this);
    this.getTahunAjaranNow = this.getTahunAjaranNow.bind(this);
    this.getKelas = this.getKelas.bind(this);
    this.getPeminatanSMA = this.getPeminatanSMA.bind(this);
    this.getBidang = this.getBidang.bind(this);
    this.getProgram = this.getProgram.bind(this);
    this.getKompetensi = this.getKompetensi.bind(this);
    this.getRombel = this.getRombel.bind(this);
    this.getRombelTarget = this.getRombelTarget.bind(this);

    this.filterTahunAjaran = this.filterTahunAjaran.bind(this);
    this.filterKurikulum = this.filterKurikulum.bind(this);
    this.filterKelas = this.filterKelas.bind(this);
    this.filterPeminatan = this.filterPeminatan.bind(this);
    this.filterBidang = this.filterBidang.bind(this);
    this.filterProgram = this.filterProgram.bind(this);
    this.filterKompetensi = this.filterKompetensi.bind(this);
    this.filterRombel = this.filterRombel.bind(this);

    this.setFilter = this.setFilter.bind(this);
    this.resetFilters = this.resetFilters.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.toggleStudentSelection = this.toggleStudentSelection.bind(this);
    this.selectAllOnPage = this.selectAllOnPage.bind(this);
    this.clearAllSelections = this.clearAllSelections.bind(this);
    this.removeFromSelection = this.removeFromSelection.bind(this);

    this.handlePindahRombel = this.handlePindahRombel.bind(this);
    this.confirmPindahRombel = this.confirmPindahRombel.bind(this);
    this.handleKeluarkanSiswa = this.handleKeluarkanSiswa.bind(this);
    this.confirmKeluarkanSiswa = this.confirmKeluarkanSiswa.bind(this);
  }

  componentDidMount() {
    // URL params will be handled in loadInitialData after session is loaded

    if (localStorage.getItem("token") !== null) {
      axios
        .post(`${conf.uri_backend}api/v1/auth/sso/user`, {
          token: localStorage.getItem("token"),
        })
        .then((res) => {
          this.setState({ data_session: res.data }, () => {
            axios
              .get(
                `${conf.uri_backend}api/v1/select-institusi/${this.state.data_session.access_to}`,
                { headers: { Authorization: tokenApi } }
              )
              .then((res) => {
                this.setState(
                  {
                    institusi_id_select: res.data.id,
                    jenjang_id_select: res.data.m_struktur_jenjang_id,
                    npsn_id_select: res.data.npsn,
                  },
                  () => {
                    this.loadInitialData();
                  }
                );
              });
          });
        });
    }
  }

  loadInitialData() {
    this.getTahunAjaranNow();
    this.getKelas();
    this.getTahunAjaranNow();
    this.getKelas();
    this.handleUrlParams();
    this.loadSavedFilter();
  }

  handleUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    const rombelId = urlParams.get('rombel_id');
    const rombelLabel = urlParams.get('rombel_label');
    const tahunAjaran = urlParams.get('tahun_ajaran');

    // hierarchy params
    const kelas = urlParams.get('kelas');
    const kurikulum = urlParams.get('kurikulum');
    const mSpektrumId = urlParams.get('m_spektrum_id');
    const namaSpektrum = urlParams.get('nama_spektrum');
    const programId = urlParams.get('program_id');
    const namaProgram = urlParams.get('nama_program');
    const bidangId = urlParams.get('bidang_id');
    const namaBidang = urlParams.get('nama_bidang');

    if (rombelId) {
      try {
        const storageKey = this.getFilterStorageKey();
        const currentFilter = JSON.parse(localStorage.getItem(storageKey) || '{}');
        const newFilter = {
          ...currentFilter,
          rombel_id: rombelId,
          rombel_label: rombelLabel || rombelId,
        };

        if (tahunAjaran) newFilter.tahun_ajaran = tahunAjaran;
        if (kelas) newFilter.kelas = kelas;
        if (kurikulum) newFilter.kurikulum = kurikulum;

        // Handle SMK/SMA specific hierarchy
        if (mSpektrumId) {
          const jenjang = String(this.state.jenjang_id_select);
          if (jenjang === '4') { // SMA
            newFilter.peminatan_id = mSpektrumId;
            newFilter.peminatan_label = namaSpektrum;
          } else if (jenjang === '5') { // SMK
            newFilter.kompetensi_id = mSpektrumId;
            newFilter.kompetensi_label = namaSpektrum;
            if (programId) {
              newFilter.program_id = programId;
              newFilter.program_label = namaProgram;
            }
            if (bidangId) {
              newFilter.bidang_id = bidangId;
              newFilter.bidang_label = namaBidang;
            }
          }
        }

        localStorage.setItem(storageKey, JSON.stringify(newFilter));

        // Also update state directly to ensure immediate reflection
        this.setState({
          rombel_search: rombelId,
          rombel_search_label: rombelLabel || rombelId,
          tahun_ajaran_search: tahunAjaran || this.state.tahun_ajaran_search,
          kelas_search: newFilter.kelas || "",
          kurikulum_search: newFilter.kurikulum || "",
          peminatan_search: newFilter.peminatan_id || "",
          peminatan_search_label: newFilter.peminatan_label || "",
          bidang_search: newFilter.bidang_id || "",
          bidang_search_label: newFilter.bidang_label || "",
          program_search: newFilter.program_id || "",
          program_search_label: newFilter.program_label || "",
          kompetensi_search: newFilter.kompetensi_id || "",
          kompetensi_search_label: newFilter.kompetensi_label || "",
        });

      } catch (e) {
        console.warn("Failed to update filter from URL:", e);
      }
    }
  }

  // Get unique localStorage key for this page and institution
  getFilterStorageKey() {
    const userId = this.state.data_session?.id || this.state.data_session?.user_id || this.state.data_session?.uuid || 'guest';
    return `filter_siswa_rombel_${this.state.institusi_id_select}_${userId}`;
  }

  // Load filter from localStorage
  loadSavedFilter() {
    try {
      const savedFilter = localStorage.getItem(this.getFilterStorageKey());
      if (savedFilter) {
        const filter = JSON.parse(savedFilter);
        this.setState(
          {
            tahun_ajaran_search: filter.tahun_ajaran || "",
            kelas_search: filter.kelas || "",
            kurikulum_search: filter.kurikulum || "",
            bidang_search: filter.bidang_id || "",
            bidang_search_label: filter.bidang_label || "",
            program_search: filter.program_id || "",
            program_search_label: filter.program_label || "",
            kompetensi_search: filter.kompetensi_id || "",
            kompetensi_search_label: filter.kompetensi_label || "",
            peminatan_search: filter.peminatan_id || "",
            peminatan_search_label: filter.peminatan_label || "",
            rombel_search: filter.rombel_id || "",
            rombel_search_label: filter.rombel_label || "",
            loadingFilter: false,
          },
          () => {
            if (this.state.kurikulum_search) {
              this.getPeminatanSMA();
              this.getBidang();
            }
          }
        );
      } else {
        this.setState({ loadingFilter: false });
      }
    } catch (e) {
      console.warn("Failed to load saved filter:", e);
      this.setState({ loadingFilter: false });
    }
  }

  // Save filter to localStorage
  saveFilterToStorage() {
    const filter = {
      tahun_ajaran: this.state.tahun_ajaran_search,
      kelas: this.state.kelas_search,
      kurikulum: this.state.kurikulum_search,
      bidang_id: this.state.bidang_search,
      bidang_label: this.state.bidang_search_label,
      program_id: this.state.program_search,
      program_label: this.state.program_search_label,
      kompetensi_id: this.state.kompetensi_search,
      kompetensi_label: this.state.kompetensi_search_label,
      peminatan_id: this.state.peminatan_search,
      peminatan_label: this.state.peminatan_search_label,
      rombel_id: this.state.rombel_search,
      rombel_label: this.state.rombel_search_label,
      savedAt: new Date().toISOString()
    };
    try {
      localStorage.setItem(this.getFilterStorageKey(), JSON.stringify(filter));
    } catch (e) {
      console.warn("Failed to save filter:", e);
    }
  }

  // Clear saved filter from localStorage
  clearSavedFilter() {
    try {
      localStorage.removeItem(this.getFilterStorageKey());
    } catch (e) {
      console.warn("Failed to clear filter:", e);
    }
  }

  // ============ FILTER DATA GETTERS ============

  getTahunAjaranNow() {
    const ta = [];
    const tahunSekarang = this.state.tahunSekarang + 1;
    for (let i = tahunSekarang; i >= 2005; i--) {
      ta.push({ value: `${i - 1} / ${i}`, label: `${i - 1} / ${i}` });
    }
    this.setState({ data_tahun_ajaran: ta });
  }

  getKelas() {
    let kelas = [];
    const jenjang = String(this.state.jenjang_id_select);

    if (jenjang === "1") {
      kelas = [
        { value: "TPA", label: "TPA (Taman Penitipan Anak)" },
        { value: "SPS", label: "SPS (Satuan PAUD Sejenis)" },
        { value: "KB", label: "KB (Kelompok Bermain)" },
        { value: "TK A", label: "TK A" },
        { value: "TK B", label: "TK B" },
      ];
    } else if (jenjang === "2") {
      kelas = [
        { value: "I", label: "I" },
        { value: "II", label: "II" },
        { value: "III", label: "III" },
        { value: "IV", label: "IV" },
        { value: "V", label: "V" },
        { value: "VI", label: "VI" },
      ];
    } else if (jenjang === "3") {
      kelas = [
        { value: "VII", label: "VII" },
        { value: "VIII", label: "VIII" },
        { value: "IX", label: "IX" },
      ];
    } else if (jenjang === "4" || jenjang === "5") {
      kelas = [
        { value: "X", label: "X" },
        { value: "XI", label: "XI" },
        { value: "XII", label: "XII" },
      ];
      if (jenjang === "5") {
        kelas.push({ value: "XIII", label: "XIII" });
      }
    }
    this.setState({ data_kelas: kelas });
  }

  getPeminatanSMA() {
    if (String(this.state.jenjang_id_select) === "4") {
      this.setState({ loading_peminatan: true });
      const kurikulum = this.state.kurikulum_search || "k13";
      axios
        .get(
          `${this.state.url_get_spektrum}?jenjang=${this.state.jenjang_id_select}&kurikulum=${kurikulum}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            data_peminatan: res.data.status ? res.data.data : [],
            loading_peminatan: false,
          });
        })
        .catch(() => {
          this.setState({ loading_peminatan: false });
        });
    }
  }

  getBidang() {
    if (String(this.state.jenjang_id_select) === "5") {
      this.setState({ loading_bidang: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=0&jenjang_id=5&kurikulum=${this.state.kurikulum_search || 'k13'}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ data_bidang: res.data, loading_bidang: false });
        })
        .catch(() => {
          this.setState({ loading_bidang: false });
        });
    }
  }

  getProgram() {
    if (String(this.state.jenjang_id_select) === "5" && this.state.bidang_search) {
      this.setState({ loading_program: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.bidang_search}&jenjang_id=5&kurikulum=${this.state.kurikulum_search || 'k13'}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({ data_program: res.data, loading_program: false });
        })
        .catch(() => {
          this.setState({ loading_program: false });
        });
    }
  }

  getKompetensi() {
    if (
      String(this.state.jenjang_id_select) === "5" &&
      this.state.program_search &&
      this.state.kurikulum_search === "k13"
    ) {
      this.setState({ loading_kompetensi: true });
      axios
        .get(
          `${this.state.url_get_smk}?parent_id=${this.state.program_search}&jenjang_id=5&kurikulum=${this.state.kurikulum_search}`,
          { headers: { Authorization: tokenApi } }
        )
        .then((res) => {
          this.setState({
            data_kompetensi: res.data,
            loading_kompetensi: false,
          });
        })
        .catch(() => {
          this.setState({ loading_kompetensi: false });
        });
    }
  }

  getRombel() {
    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;
    const kurikulum = this.state.kurikulum_search || "k13";

    this.setState({ loading_rombel: true });
    axios
      .get(
        `${this.state.url_get_rombel}?tahun_ajaran=${this.state.tahun_ajaran_search}&kelas=${this.state.kelas_search}&peminatan=${peminatan}&user_institusi_id=${this.state.institusi_id_select}&kurikulum=${kurikulum}&program_id=${this.state.program_search}&bidang_id=${this.state.bidang_search}`,
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({ data_rombel: res.data, loading_rombel: false });
      })
      .catch(() => {
        this.setState({ loading_rombel: false });
      });
  }

  getRombelTarget() {
    // Get rombels for target selection with same tahun ajaran and same kelas (excluding current)
    const kurikulum = this.state.kurikulum_search || "k13";
    const kelas = this.state.kelas_search || "";

    // Add peminatan/kompetensi for SMA/SMK hierarchy if available
    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;

    axios
      .get(
        `${this.state.url_get_rombel}?tahun_ajaran=${this.state.tahun_ajaran_search}&kelas=${kelas}&peminatan=${peminatan || ""}&user_institusi_id=${this.state.institusi_id_select}&kurikulum=${kurikulum}&program_id=${this.state.program_search || ""}&bidang_id=${this.state.bidang_search || ""}`,
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        // Filter out current rombel
        const filtered = res.data.filter(
          (r) => r.value !== this.state.rombel_search
        );
        this.setState({ data_rombel_target: filtered });
      });
  }

  // ============ FILTER HANDLERS ============

  filterTahunAjaran(e) {
    if (e) {
      this.setState(
        {
          tahun_ajaran_search: e.value,
          kurikulum_search: "",
          kelas_search: "",
          peminatan_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
          rombel_search: "",
          rombel_search_label: "",
          data_rombel: [],
        },
        () => {
          if (this.state.kelas_search) {
            this.getRombel();
          }
        }
      );
    }
  }

  filterKurikulum(e) {
    if (e) {
      this.setState(
        {
          kurikulum_search: e.value,
          kelas_search: "",
          peminatan_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
          rombel_search: "",
          rombel_search_label: "",
          data_peminatan: [],
          data_bidang: [],
          data_program: [],
          data_kompetensi: [],
          data_rombel: [],
        },
        () => {
          this.getKelas();
          this.getPeminatanSMA();
          this.getBidang();
        }
      );
    }
  }

  filterKelas(e) {
    if (e) {
      this.setState(
        {
          kelas_search: e.value,
          peminatan_search: "",
          bidang_search: "",
          program_search: "",
          kompetensi_search: "",
          rombel_search: "",
          rombel_search_label: "",
          data_rombel: [],
        },
        () => {
          this.getRombel();
        }
      );
    }
  }

  filterPeminatan(e) {
    if (e) {
      this.setState(
        {
          peminatan_search: e.value,
          peminatan_search_label: e.label,
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getRombel();
        }
      );
    }
  }

  filterBidang(e) {
    if (e) {
      this.setState(
        {
          bidang_search: e.value,
          bidang_search_label: e.label,
          program_search: "",
          program_search_label: "",
          kompetensi_search: "",
          kompetensi_search_label: "",
          data_program: [],
          data_kompetensi: [],
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getProgram();
        }
      );
    } else {
      this.setState({
        bidang_search: "",
        bidang_search_label: "",
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        data_program: [],
        data_kompetensi: [],
      });
    }
  }

  filterProgram(e) {
    if (e) {
      this.setState(
        {
          program_search: e.value,
          program_search_label: e.label,
          kompetensi_search: "",
          kompetensi_search_label: "",
          data_kompetensi: [],
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          if (this.state.kurikulum_search === "k13") {
            this.getKompetensi();
          } else {
            this.getRombel();
          }
        }
      );
    } else {
      this.setState({
        program_search: "",
        program_search_label: "",
        kompetensi_search: "",
        kompetensi_search_label: "",
        data_kompetensi: [],
      });
    }
  }

  filterKompetensi(e) {
    if (e) {
      this.setState(
        {
          kompetensi_search: e.value,
          kompetensi_search_label: e.label,
          rombel_search: "",
          rombel_search_label: "",
        },
        () => {
          this.getRombel();
        }
      );
    } else {
      this.setState({
        kompetensi_search: "",
        kompetensi_search_label: ""
      });
    }
  }

  filterRombel(e) {
    if (e) {
      this.setState({
        rombel_search: e.value,
        rombel_search_label: e.label,
      });
    }
  }

  // Reset all filters
  resetFilters() {
    this.clearSavedFilter();
    this.setState({
      tahun_ajaran_search: "",
      kelas_search: "",
      kurikulum_search: "",
      peminatan_search: "",
      peminatan_search_label: "",
      bidang_search: "",
      bidang_search_label: "",
      program_search: "",
      program_search_label: "",
      kompetensi_search: "",
      kompetensi_search_label: "",
      rombel_search: "",
      rombel_search_label: "",
      searchText: "",
      data_kelas: [],
      data_peminatan: [],
      data_bidang: [],
      data_program: [],
      data_kompetensi: [],
      data_rombel: [],
      showDataTable: false,
    });
  }

  // ============ ACTIONS ============

  setFilter() {
    if (!this.state.rombel_search) {
      this.setState({
        show_alert: true,
        title_alert: "Peringatan",
        icon_alert: "warning",
        message_alert: "Pilih rombel terlebih dahulu",
      });
      return;
    }

    const peminatan =
      String(this.state.jenjang_id_select) === "5"
        ? this.state.kompetensi_search
        : this.state.peminatan_search;

    const query = `&kelas=${this.state.kelas_search}&m_spektrum_id=${peminatan}&tahun_ajaran=${this.state.tahun_ajaran_search}&rombel_id=${this.state.rombel_search}&institusi_id=${this.state.institusi_id_select}&kurikulum=${this.state.kurikulum_search}&query=${this.state.searchText}&per_page=${this.state.mode_show}`;

    this.saveFilterToStorage();
    this.setState(
      {
        query,
        showDataTable: true,
        selectedStudents: new Map(),
        loadingSearch: true,
      },
      () => {
        if (this.dt) {
          this.dt.loading();
          this.dt.resetPage(query);
        }
      }
    );
  }

  handleSearch(e) {
    const searchText = e.target.value;
    this.setState({ searchText }, () => {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        if (this.state.showDataTable) {
          this.setFilter();
        }
      }, 300);
    });
  }

  toggleStudentSelection(student) {
    this.setState((prevState) => {
      const newMap = new Map(prevState.selectedStudents);
      if (newMap.has(student.id)) {
        newMap.delete(student.id);
      } else {
        newMap.set(student.id, student);
      }
      return { selectedStudents: newMap };
    });
  }

  selectAllOnPage() {
    const checkboxes = document.querySelectorAll("input.select-checkbox");
    checkboxes.forEach((cb) => {
      if (!cb.checked) {
        const event = new MouseEvent("click", { bubbles: true });
        cb.dispatchEvent(event);
      }
    });
  }

  clearAllSelections() {
    this.setState({ selectedStudents: new Map() });
  }

  removeFromSelection(studentId) {
    this.setState((prevState) => {
      const newMap = new Map(prevState.selectedStudents);
      newMap.delete(studentId);
      return { selectedStudents: newMap };
    });
  }

  // ============ PINDAH ROMBEL ============

  handlePindahRombel() {
    if (this.state.selectedStudents.size === 0) {
      this.setState({
        show_alert: true,
        title_alert: "Peringatan",
        icon_alert: "warning",
        message_alert: "Pilih minimal satu siswa terlebih dahulu",
      });
      return;
    }
    this.getRombelTarget();
    this.setState({ showPindahModal: true });
  }

  confirmPindahRombel() {
    if (!this.state.pindah_rombel_target) {
      this.setState({
        show_alert: true,
        title_alert: "Peringatan",
        icon_alert: "warning",
        message_alert: "Pilih rombel tujuan terlebih dahulu",
      });
      return;
    }

    this.setState({ loading_action: true });
    const studentIds = Array.from(this.state.selectedStudents.values()).map(
      (s) => s.user_siswa_id || s.id
    );

    axios
      .post(
        this.state.url_pindah_rombel,
        {
          siswa_id: studentIds,
          tahun_ajaran: this.state.tahun_ajaran_search,
          rombel_id: this.state.pindah_rombel_target,
          created_by: this.state.institusi_id_select,
        },
        { headers: { Authorization: tokenApi } }
      )
      .then((res) => {
        this.setState({
          loading_action: false,
          showPindahModal: false,
          pindah_rombel_target: "",
          pindah_rombel_target_label: "",
          selectedStudents: new Map(),
          show_alert: true,
          title_alert: res.data.status ? "Berhasil" : "Gagal",
          icon_alert: res.data.status ? "success" : "error",
          message_alert: Array.isArray(res.data.messages)
            ? res.data.messages[0]
            : res.data.messages,
        });
        if (this.dt) {
          this.dt.fetchEntities(this.state.query);
        }
      })
      .catch((err) => {
        const errorMessage =
          err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : "Terjadi kesalahan";
        this.setState({
          loading_action: false,
          show_alert: true,
          title_alert: "Gagal",
          icon_alert: "error",
          message_alert: errorMessage,
        });
      });
  }

  // ============ KELUARKAN SISWA ============

  handleKeluarkanSiswa() {
    if (this.state.selectedStudents.size === 0) {
      this.setState({
        show_alert: true,
        title_alert: "Peringatan",
        icon_alert: "warning",
        message_alert: "Pilih minimal satu siswa terlebih dahulu",
      });
      return;
    }
    // Directly call confirm which shows swal
    this.confirmKeluarkanSiswa();
  }

  confirmKeluarkanSiswa() {
    this.setState({ loading_action: true });

    const selectedArr = Array.from(this.state.selectedStudents.values());
    const siswaIdRombel = selectedArr.map((s) => s.id);
    const siswaId = selectedArr.map((s) => s.user_siswa_id);

    swal
      .fire({
        title: "Konfirmasi",
        text: `Apakah Anda yakin ingin mengeluarkan ${selectedArr.length} siswa dari rombel?`,
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ya, Keluarkan",
        cancelButtonText: "Batal",
        confirmButtonColor: "#ef4444",
      })
      .then((result) => {
        if (result.isConfirmed) {
          axios
            .post(
              this.state.url_delete,
              {
                rombel: this.state.rombel_search,
                siswa_id_rombel: siswaIdRombel,
                siswa_id: siswaId,
              },
              { headers: { Authorization: tokenApi } }
            )
            .then((res) => {
              this.setState({
                loading_action: false,
                showKeluarkanModal: false,
                selectedStudents: new Map(),
                show_alert: true,
                title_alert: res.data.status ? "Berhasil" : "Gagal",
                icon_alert: res.data.status ? "success" : "error",
                message_alert: "Siswa berhasil dikeluarkan dari rombel",
              });
              if (this.dt) {
                this.dt.fetchEntities(this.state.query);
              }
            })
            .catch((err) => {
              const errorMessage =
                err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : "Terjadi kesalahan";
              this.setState({
                loading_action: false,
                show_alert: true,
                title_alert: "Gagal",
                icon_alert: "error",
                message_alert: errorMessage,
              });
            });
        } else {
          this.setState({ loading_action: false, showKeluarkanModal: false });
        }
      });
  }

  // ============ RENDER METHODS ============

  renderFilterPanel() {
    return (
      <div className="glass-card p-6 mb-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-blue-cyan flex items-center justify-center mr-3">
              <i className="bx bx-group text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">
                Siswa per Rombel
              </h2>
              <p className="text-sm text-gray-500">
                Kelola siswa dalam rombongan belajar
              </p>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {/* Tahun Ajaran */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                1
              </span>
              Tahun Ajaran
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_tahun_ajaran}
              value={
                this.state.tahun_ajaran_search
                  ? {
                    value: this.state.tahun_ajaran_search,
                    label: this.state.tahun_ajaran_search,
                  }
                  : null
              }
              onChange={this.filterTahunAjaran}
              placeholder="Pilih Tahun Ajaran"
              isLoading={this.state.loadingFilter}
            />
          </div>

          {/* Kurikulum */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.tahun_ajaran_search
                  ? "bg-indigo-100 text-indigo-600"
                  : "bg-gray-100 text-gray-400"
                  } text-xs font-bold mr-2`}
              >
                2
              </span>
              Jenis Kurikulum
            </label>
            <Select
              styles={selectStyles}
              options={dataKurikulum}
              value={
                this.state.kurikulum_search
                  ? {
                    value: this.state.kurikulum_search,
                    label: this.state.kurikulum_search.toUpperCase(),
                  }
                  : null
              }
              onChange={this.filterKurikulum}
              placeholder={
                this.state.tahun_ajaran_search
                  ? "Pilih Kurikulum"
                  : "Pilih Tahun Ajaran dulu"
              }
              isDisabled={!this.state.tahun_ajaran_search}
            />
          </div>

          {/* Kelas */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kurikulum_search
                  ? "bg-indigo-100 text-indigo-600"
                  : "bg-gray-100 text-gray-400"
                  } text-xs font-bold mr-2`}
              >
                3
              </span>
              Kelas
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_kelas}
              value={
                this.state.kelas_search
                  ? {
                    value: this.state.kelas_search,
                    label: this.state.kelas_search,
                  }
                  : null
              }
              onChange={this.filterKelas}
              placeholder={
                this.state.kurikulum_search
                  ? "Pilih Kelas"
                  : "Pilih Kurikulum dulu"
              }
              isDisabled={!this.state.kurikulum_search}
            />
          </div>

          {/* Peminatan - SMA */}
          {String(this.state.jenjang_id_select) === "4" && (
            <div className="filter-group">
              <label className="block text-sm font-medium text-gray-700 mb-2">
                <span
                  className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search
                    ? "bg-indigo-100 text-indigo-600"
                    : "bg-gray-100 text-gray-400"
                    } text-xs font-bold mr-2`}
                >
                  4
                </span>
                Peminatan
              </label>
              <Select
                styles={selectStyles}
                options={this.state.data_peminatan}
                value={this.state.peminatan_search ? { value: this.state.peminatan_search, label: this.state.peminatan_search_label || this.state.peminatan_search } : null}
                onChange={this.filterPeminatan}
                placeholder={
                  this.state.kelas_search
                    ? "Pilih Peminatan"
                    : "Pilih Kelas dulu"
                }
                isLoading={this.state.loading_peminatan}
                isDisabled={!this.state.kelas_search}
              />
            </div>
          )}

          {/* SMK Filters */}
          {String(this.state.jenjang_id_select) === "5" &&
            this.renderSMKFilters()}

          {/* Rombel */}
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span
                className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search
                  ? "bg-green-100 text-green-600"
                  : "bg-gray-100 text-gray-400"
                  } text-xs font-bold mr-2`}
              >
                5
              </span>
              Rombel
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_rombel}
              value={
                this.state.rombel_search
                  ? {
                    value: this.state.rombel_search,
                    label: this.state.rombel_search_label,
                  }
                  : null
              }
              onChange={this.filterRombel}
              placeholder={
                this.state.kelas_search ? "Pilih Rombel" : "Pilih Kelas dulu"
              }
              isLoading={this.state.loading_rombel}
              isDisabled={!this.state.kelas_search}
            />
          </div>
        </div>

        {/* Action Buttons */}
        <div className="mt-6 flex justify-center gap-3">
          <button
            className="px-6 py-3 border-2 border-gray-300 text-gray-700 font-semibold rounded-xl hover:bg-gray-50 transition-all duration-200 flex items-center"
            onClick={this.resetFilters}
          >
            <i className="bx bx-reset text-xl mr-2"></i>
            Reset Filter
          </button>
          <button
            className={`px-8 py-3 ${this.state.rombel_search
              ? "btn-gradient-blue-cyan hover:shadow-xl transform hover:-translate-y-0.5"
              : "bg-gray-300 cursor-not-allowed"
              } text-white font-semibold rounded-xl shadow-lg transition-all duration-200 flex items-center`}
            onClick={this.setFilter}
            disabled={!this.state.rombel_search}
          >
            <i className="bx bx-search-alt-2 text-xl mr-2"></i>
            Tampilkan Siswa
          </button>
        </div>
      </div>
    );
  }

  renderSMKFilters() {
    return (
      <>
        {/* Bidang */}
        <div className="filter-group">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            <span
              className={`inline-flex items-center justify-center w-6 h-6 rounded-full ${this.state.kelas_search
                ? "bg-indigo-100 text-indigo-600"
                : "bg-gray-100 text-gray-400"
                } text-xs font-bold mr-2`}
            >
              4a
            </span>
            Bidang Keahlian
          </label>
          <Select
            styles={selectStyles}
            options={this.state.data_bidang}
            value={this.state.bidang_search ? { value: this.state.bidang_search, label: this.state.bidang_search_label || this.state.bidang_search } : null}
            onChange={this.filterBidang}
            placeholder="Pilih Bidang"
            isLoading={this.state.loading_bidang}
            isDisabled={!this.state.kelas_search}
            isClearable
          />
        </div>

        {/* Program */}
        {this.state.bidang_search && (
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                4b
              </span>
              Program Keahlian
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_program}
              value={this.state.program_search ? { value: this.state.program_search, label: this.state.program_search_label || this.state.program_search } : null}
              onChange={this.filterProgram}
              placeholder="Pilih Program"
              isLoading={this.state.loading_program}
              isClearable
            />
          </div>
        )}

        {/* Kompetensi - only for K13 */}
        {this.state.program_search && this.state.kurikulum_search === "k13" && (
          <div className="filter-group">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              <span className="inline-flex items-center justify-center w-6 h-6 rounded-full bg-indigo-100 text-indigo-600 text-xs font-bold mr-2">
                4c
              </span>
              Kompetensi Keahlian
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_kompetensi}
              value={this.state.kompetensi_search ? { value: this.state.kompetensi_search, label: this.state.kompetensi_search_label || this.state.kompetensi_search } : null}
              onChange={this.filterKompetensi}
              placeholder="Pilih Kompetensi"
              isLoading={this.state.loading_kompetensi}
              isClearable
            />
          </div>
        )}
      </>
    );
  }

  renderDataTable() {
    if (!this.state.showDataTable) return null;

    const selectedCount = this.state.selectedStudents.size;

    return (
      <div className="glass-card p-6 mb-6">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-4">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-emerald-teal flex items-center justify-center mr-3">
              <i className="bx bx-list-ul text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">
                Daftar Siswa - {this.state.rombel_search_label}
              </h2>
              <p className="text-sm text-gray-500">
                {selectedCount > 0 ? `${selectedCount} siswa dipilih` : "Pilih siswa untuk aksi"} {this.dt?.state?.total ? `(Total Data: ${this.dt.state.total})` : ""}
              </p>
            </div>
          </div>

          {/* Actions */}
          <div className="flex items-center gap-2 flex-wrap">
            {/* Search */}
            <div className="relative">
              <input
                type="search"
                className="pl-10 pr-4 py-2 rounded-xl border border-gray-200 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 outline-none transition-all w-56"
                placeholder="Cari siswa..."
                onChange={this.handleSearch}
              />
              <i className="bx bx-search absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"></i>
            </div>

            {/* Pagination */}
            <div className="flex items-center gap-1">
              {[10, 50, 100].map((num) => (
                <button
                  key={num}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-all ${this.state.mode_show === num
                    ? "bg-blue-500 text-white"
                    : "bg-gray-100 text-gray-600 hover:bg-gray-200"
                    }`}
                  onClick={() =>
                    this.setState({ mode_show: num }, this.setFilter)
                  }
                >
                  {num}
                </button>
              ))}
            </div>

            {/* Select All */}
            <button
              className="px-4 py-2 bg-indigo-100 text-indigo-700 font-medium rounded-lg hover:bg-indigo-200 transition-all flex items-center text-sm"
              onClick={this.selectAllOnPage}
            >
              <i className="bx bx-check-double text-lg mr-1"></i>
              Pilih Semua
            </button>
          </div>
        </div>

        {/* DataTable */}
        <DataTable
          ref={(dt) => {
            this.dt = dt;
          }}
          action={{
            no: (col, data, index) => {
              const page = this.dt?.state?.entities?.current_page || this.dt?.state?.current_page || 1;
              const perPage = this.dt?.state?.entities?.per_page || this.state.mode_show || 10;
              return (page - 1) * perPage + index + 1;
            },


            pilih: (col, data) => (
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  className="select-checkbox sr-only peer"
                  checked={this.state.selectedStudents.has(data.id)}
                  onChange={() => this.toggleStudentSelection(data)}
                />
                <div className="w-6 h-6 rounded-lg border-2 border-gray-300 peer-checked:border-blue-500 peer-checked:bg-blue-500 flex items-center justify-center transition-all">
                  <i
                    className={`bx bx-check text-white ${this.state.selectedStudents.has(data.id)
                      ? "opacity-100"
                      : "opacity-0"
                      } transition-opacity`}
                  ></i>
                </div>
              </label>
            ),
            jenis_kelamin: (col, data) => {
              // Handle 0 (Female) correctly by not using || operator which treats 0 as falsy
              const rawVal = data.jenis_kelamin;
              const val = (rawVal !== null && rawVal !== undefined ? String(rawVal) : "").toUpperCase().trim();

              const isMale = val === "1" || val === "L" || val === "M" || val === "LAKI-LAKI" || val === "LAKI - LAKI" || val === "MALE";
              const isFemale = val === "0" || val === "P" || val === "F" || val === "PEREMPUAN" || val === "FEMALE";

              let label = isMale ? "L" : (isFemale ? "P" : "-");
              let color = isMale ? "bg-blue-100 text-blue-700" : (isFemale ? "bg-pink-100 text-pink-700" : "bg-gray-100 text-gray-700");

              return (
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}
                >
                  {label}
                </span>
              );
            },
            tanggal_lahir: (col, data) => {
              if (!data.tanggal_lahir) return "-";
              const date = new Date(data.tanggal_lahir);
              return date.toLocaleDateString("id-ID", {
                day: "2-digit",
                month: "short",
                year: "numeric",
              });
            },
            status: (col, data) => {
              const val = String(data.status || "").toLowerCase().trim();
              const isActive = val === "aktif" || val === "active" || val === "1" || val === "true";
              const isNonActive = val === "non-aktif" || val === "non-active" || val === "inactive" || val === "0" || val === "false";

              let label = isActive ? "Aktif" : (isNonActive ? "Non-Aktif" : (data.status || "Pending"));
              let color = isActive ? "bg-green-100 text-green-700" : (isNonActive ? "bg-red-100 text-red-700" : "bg-yellow-100 text-yellow-700");

              return (
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${color}`}
                >
                  {label}
                </span>
              );
            },
          }}
          url={this.state.url}
          columns={[
            { index: "no", label: "No" },
            { index: "kode_pendaftaran", label: "Kode Pendaftaran" },
            { index: "nama", label: "Nama Lengkap" },
            { index: "email", label: "Email" },
            { index: "jenis_kelamin", label: "JK" },
            { index: "tanggal_lahir", label: "Tanggal Lahir" },
            { index: "status", label: "Status" },
            { index: "pilih", label: "Pilih" },
          ]}
        />
      </div>
    );
  }

  renderSelectionPanel() {
    const selectedCount = this.state.selectedStudents.size;
    const selectedStudents = Array.from(this.state.selectedStudents.values());

    if (!this.state.showDataTable) return null;

    return (
      <div className="glass-card p-6 sticky top-4">
        <div className="flex items-center justify-between mb-4">
          <div className="flex items-center">
            <div className="w-10 h-10 rounded-xl icon-gradient-violet-purple flex items-center justify-center mr-3">
              <i className="bx bx-list-check text-white text-xl"></i>
            </div>
            <div>
              <h2 className="text-lg font-bold text-gray-800">
                Siswa Terpilih
              </h2>
              <p className="text-sm text-gray-500">
                {selectedCount} siswa dipilih
              </p>
            </div>
          </div>
          {selectedCount > 0 && (
            <button
              className="text-red-500 hover:text-red-700 text-sm font-medium"
              onClick={this.clearAllSelections}
            >
              Hapus Semua
            </button>
          )}
        </div>

        <div className="max-h-80 overflow-y-auto space-y-2">
          {selectedCount === 0 ? (
            <div className="text-center py-8 text-gray-400">
              <i className="bx bx-user-check text-4xl mb-2"></i>
              <p className="text-sm">Belum ada siswa dipilih</p>
            </div>
          ) : (
            selectedStudents.map((student) => (
              <div
                key={student.id}
                className="flex items-center justify-between p-3 bg-gradient-to-r from-gray-50 to-white rounded-xl border border-gray-100 hover:shadow-md transition-all group"
              >
                <div className="flex items-center">
                  <div className="w-8 h-8 rounded-lg bg-violet-100 flex items-center justify-center mr-3">
                    <i className="bx bx-user text-violet-600"></i>
                  </div>
                  <div>
                    <p className="font-medium text-gray-800 text-sm">
                      {student.nama}
                    </p>
                    <p className="text-xs text-gray-500">{student.nisn}</p>
                  </div>
                </div>
                <button
                  className="opacity-0 group-hover:opacity-100 w-6 h-6 rounded-full bg-red-100 text-red-500 hover:bg-red-500 hover:text-white flex items-center justify-center transition-all"
                  onClick={() => this.removeFromSelection(student.id)}
                >
                  <i className="bx bx-x"></i>
                </button>
              </div>
            ))
          )}
        </div>

        {/* Action Buttons */}
        {selectedCount > 0 && (
          <div className="mt-4 pt-4 border-t border-gray-100 space-y-2">
            <button
              className="w-full px-4 py-3 btn-gradient-amber font-medium rounded-xl hover:shadow-lg transition-all flex items-center justify-center"
              onClick={this.handlePindahRombel}
            >
              <i className="bx bx-transfer text-lg mr-2"></i>
              Pindah Rombel ({selectedCount})
            </button>
            <button
              className="w-full px-4 py-3 btn-gradient-red font-medium rounded-xl hover:shadow-lg transition-all flex items-center justify-center"
              onClick={this.handleKeluarkanSiswa}
            >
              <i className="bx bx-user-minus text-lg mr-2"></i>
              Keluarkan Siswa ({selectedCount})
            </button>
          </div>
        )}
      </div>
    );
  }

  renderPindahModal() {
    const selectedStudents = Array.from(this.state.selectedStudents.values());

    return (
      <Modal
        show={this.state.showPindahModal}
        onHide={() =>
          this.setState({
            showPindahModal: false,
            pindah_rombel_target: "",
            pindah_rombel_target_label: "",
          })
        }
        size="lg"
        centered
      >
        <div className="p-6">
          <div className="text-center mb-6">
            <div className="w-16 h-16 mx-auto rounded-full bg-amber-100 flex items-center justify-center mb-4">
              <i className="bx bx-transfer text-amber-500 text-3xl"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-800">Pindah Rombel</h3>
            <p className="text-gray-500 mt-2">
              Pindahkan <strong>{selectedStudents.length} siswa</strong> ke
              rombel lain
            </p>
          </div>

          {/* Target Rombel Selection */}
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Pilih Rombel Tujuan
            </label>
            <Select
              styles={selectStyles}
              options={this.state.data_rombel_target}
              value={
                this.state.pindah_rombel_target
                  ? {
                    value: this.state.pindah_rombel_target,
                    label: this.state.pindah_rombel_target_label,
                  }
                  : null
              }
              onChange={(e) =>
                e &&
                this.setState({
                  pindah_rombel_target: e.value,
                  pindah_rombel_target_label: e.label,
                })
              }
              placeholder="Pilih rombel tujuan..."
            />
          </div>

          {/* Student List */}
          <div className="max-h-48 overflow-y-auto mb-6 border rounded-xl p-3">
            {selectedStudents.map((student, idx) => (
              <div
                key={student.id}
                className="flex items-center py-2 border-b last:border-0"
              >
                <span className="w-6 text-gray-400 text-sm">{idx + 1}.</span>
                <span className="font-medium text-gray-800">{student.nama}</span>
              </div>
            ))}
          </div>

          {/* Actions */}
          <div className="flex gap-3 justify-end">
            <button
              className="px-6 py-2 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition-all"
              onClick={() =>
                this.setState({
                  showPindahModal: false,
                  pindah_rombel_target: "",
                  pindah_rombel_target_label: "",
                })
              }
            >
              Batal
            </button>
            <button
              className="px-6 py-2 rounded-xl btn-gradient-amber font-medium hover:shadow-lg transition-all flex items-center"
              onClick={this.confirmPindahRombel}
              disabled={this.state.loading_action}
            >
              {this.state.loading_action ? (
                <UserButtonLoading />
              ) : (
                <>
                  <i className="bx bx-transfer mr-2"></i>
                  Pindahkan
                </>
              )}
            </button>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-cyan-50 py-6">
        <SweetAlert
          show={this.state.show_alert}
          title={this.state.title_alert}
          text={this.state.message_alert}
          type={this.state.icon_alert}
          onConfirm={() => this.setState({ show_alert: false })}
          onOutsideClick={() => this.setState({ show_alert: false })}
        />

        <div className="sm-container mx-auto px-4">
          {/* Header */}
          <div className="mb-6">
            <div className="flex items-center">
              <div className="w-12 h-12 rounded-2xl icon-gradient-blue-cyan flex items-center justify-center mr-4 shadow-lg">
                <i className="bx bx-group text-white text-2xl"></i>
              </div>
              <div>
                <h1 className="text-2xl font-bold text-gray-800">
                  Siswa per Rombel
                </h1>
                <p className="text-gray-500">
                  Kelola dan atur siswa dalam rombongan belajar
                </p>
              </div>
            </div>
          </div>

          {/* Loading State */}
          {this.state.loadingFilter ? (
            <div className="glass-card p-8">
              <div className="flex flex-col items-center justify-center">
                <Skeleton width={200} height={20} className="mb-4" />
                <Skeleton width={300} height={40} className="mb-2" />
                <Skeleton width={300} height={40} className="mb-2" />
                <Skeleton width={300} height={40} />
              </div>
            </div>
          ) : (
            <>
              {/* Filter Panel */}
              {this.renderFilterPanel()}

              {/* Main Content */}
              {this.state.showDataTable && (
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                  {/* DataTable - 2/3 width */}
                  <div className="lg:col-span-2">{this.renderDataTable()}</div>

                  {/* Selection Panel - 1/3 width */}
                  <div className="lg:col-span-1">
                    {this.renderSelectionPanel()}
                  </div>
                </div>
              )}
            </>
          )}
        </div>

        {/* Modals */}
        {this.renderPindahModal()}
      </div>
    );
  }
}